import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HomeBriefingComponent } from '../../Partials/home-briefing/home-briefing.component';
import { HomeSpotlightComponent } from '../../Partials/home-spotlight/home-spotlight.component';
import { HomeAttentionQueueComponent } from '../../Partials/home-attention-queue/home-attention-queue.component';
import { HomePulseComponent } from '../../Partials/home-pulse/home-pulse.component';
import { HomeLauncherComponent } from '../../Partials/home-launcher/home-launcher.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    HomeBriefingComponent,
    HomeSpotlightComponent,
    HomeAttentionQueueComponent,
    HomePulseComponent,
    HomeLauncherComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {}
